const bazarListNp = {
  banner: {
    title: 'बजारहरू',
    subtitle: 'हजारौं परम्परागत ग्रामीण बजारबाट किनमेल गर्नुहोस्',
    breadcrumbLabel: 'बजारहरू',
    currentPlaceholder: 'खाना खोज्नुहोस्...'
  },
  filter: {
    title: 'फिल्टर विकल्प',
    searchPlaceholder: 'बजार खोज्नुहोस्...',
    district: 'जिल्ला',
    upazilla: 'उपजिल्ला',
    size: 'बजारको आकार',
    sortBy: 'क्रमबद्ध गर्नुहोस्',
    sortOptions: {
      name: 'नाम',
      storeCount: 'स्टोर संख्या',
      rating: 'रेटिङ',
      visitors: 'लोकप्रियता'
    },
    clearShort: 'हटाउनुहोस्',
    clearAll: 'सबै हटाउनुहोस्',
    activeFilters: 'सक्रिय फिल्टर:',
    labels: {
      search: 'खोज',
      district: 'जिल्ला',
      upazilla: 'उपजिल्ला',
      size: 'आकार'
    }
  },
  results: {
    foundSuffix: 'बजार भेटिए',
    none: 'कुनै बजार भेटिएन',
    page: 'पृष्ठ'
  },
  empty: {
    title: 'तपाईंको खोजसँग मिल्ने कुनै बजार भेटिएन',
    subtitle: 'फिल्टर परिवर्तन गरेर प्रयास गर्नुहोस् वा सबै फिल्टर हटाउनुहोस्',
    clear: 'सबै फिल्टर हटाउनुहोस्'
  },
  card: {
    stores: 'स्टोर',
    dailyVisitors: 'दैनिक दर्शक',
    specialties: 'विशेषता:',
    details: 'विवरण',
    visit: 'भ्रमण गर्नुहोस्'
  },
  dialog: {
    title: 'बधाई छ!',
    selected: 'तपाईंको बजार चयन भयो',
    instruction: 'तपाईंको वर्तमान बजार चयन गरिएको छ। तलबाट कुन क्याटेगरीमा किनमेल गर्न चाहनुहुन्छ चयन गर्नुहोस्:',
    categoryPrompt: 'के किन्न चाहनुहुन्छ?',
    bottomNotePrefix: 'यी वस्तुहरू',
    bottomNoteSuffix: 'बाट उपलब्ध गराइनेछ',
    close: 'पछि हेर्छु'
  }
};

export default bazarListNp;


